import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  DeploymentRequestInfomationInputDialogContext,
  DeploymentRequestInfomationInputDialogInitialState,
} from ".";

export const DeploymentRequestInfomationInputDialogStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    DeploymentRequestInfomationInputDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <DeploymentRequestInfomationInputDialogContext.Provider value={context}>
      {children}
    </DeploymentRequestInfomationInputDialogContext.Provider>
  );
};
